// 物件確認モーダル
const ModalHappyCall = {
  namespaced: true,

  state: {
    modal: false,
    id: null,
    mBTypeId: null,
    formItem: {
      b_price_low: null,
      mi_sale_state_cd: null,
      m_vacant_type_id: null,
      delivery_term_y: null,
      delivery_term_m: null,
      delivery_term_d: null,
      confirm_y: null,
      confirm_m: null,
      confirm_d: null,
      ea_id: null,
      um_eachargeperson_id: null,
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getId: state => {
      return state.id
    },
    getMBTypeId: state => {
      return state.mBTypeId
    },
    getFormItem: state => {
      return state.formItem
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setId(state, id) {
      state.id = id
    },
    setMBTypeId(state, mBTypeId) {
      state.mBTypeId = mBTypeId
    },
    setFormItem(state, formItem) {
      state.formItem = formItem
    },
  },
  actions: {
    set({ commit }, item) {
      const formItem = {
        b_price_low: item.b_price_low,
        mi_sale_state_cd: item.mi_sale_state_cd,
        m_vacant_type_id: item.m_vacant_type_id,
        delivery_term_y: item.delivery_term_y,
        delivery_term_m: item.delivery_term_m,
        delivery_term_d: item.delivery_term_d,
        confirm_y: item.confirm_y,
        confirm_m: item.confirm_m,
        confirm_d: item.confirm_d,
        ea_id: item.ea_id,
        um_eachargeperson_id: item.um_eachargeperson_id,
      }
      commit('setFormItem', formItem)
      commit('setMBTypeId', item.m_b_type_id)
      commit('setId', item.id)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      const formItem = {
        b_price_low: null,
        mi_sale_state_cd: null,
        m_vacant_type_id: null,
        delivery_term_y: null,
        delivery_term_m: null,
        delivery_term_d: null,
        confirm_y: null,
        confirm_m: null,
        confirm_d: null,
        ea_id: null,
        um_eachargeperson_id: null,
      }
      commit('setFormItem', formItem)
      commit('setMBTypeId', null)
      commit('setId', null)
    },
  },
}

export default ModalHappyCall
